import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ContentLoader } from '@saucelabs/sl-component-loader';

import * as operations from './../ducks/users/operations';
import * as actions from './../ducks/users/actions';

const JobsUserContainer = memo((props) => {
  const {
    children,
    cleanup,
    initialize,
    loading,
    username,
  } = props;

  useEffect(() => {
    initialize({ username });

    return cleanup;
  }, [username]);

  return (
    <ContentLoader show={loading}>
      {children}
    </ContentLoader>
  );
});

const mapStateToProps = ({ apps: { jobs: { users } }, user }, { username }) => ({
  loading: users.get('loading'),
  username: username || user.get('username'),
});


const mapDispatchToProps = {
  initialize: operations.initialize,
  cleanup: actions.cleanup,
};

JobsUserContainer.propTypes = {
  children: PropTypes.node.isRequired,
  cleanup: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobsUserContainer));
export {
  JobsUserContainer,
  mapStateToProps,
};
